import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const npoLoginSchema = Yup.object().shape({
  email: Yup.string().required(i18n.t('mix.required_email')).email(i18n.t('mix.valid_email')),
  password: Yup.string()
    .required(i18n.t('auth.pw_required'))
    .min(8, i18n.t('mix.min_length', { LENGTH: 8 }))
    .matches(/(?=.*[A-Z])/, i18n.t('auth.min_uppercase'))
    .matches(/(?=.*[0-9])/, i18n.t('auth.min_numbers'))
    .matches(/(?=.*[a-z])/, i18n.t('auth.min_lowercase'))
});

const npoForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().required(i18n.t('mix.required_email')).email(i18n.t('mix.valid_email'))
});

const signInSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, i18n.t('mix.min_length', { LENGTH: 2 }))
    .required(i18n.t('auth.name_required')),
  lastName: Yup.string()
    .min(2, i18n.t('mix.min_length', { LENGTH: 2 }))
    .required(i18n.t('auth.last_name_required'))
});

const interestsSchema = Yup.object().shape({
  denominations: Yup.array().of(Yup.string().required()),
  religions: Yup.array().of(Yup.string().required()),
  programs: Yup.array().of(Yup.string().required()),
  checkbox_selection: Yup.string().when(['denominations', 'religions', 'programs'], {
    is: (denominations: string[], religions: string[], programs: string[]) =>
      denominations.length === 0 && religions.length === 0 && programs.length === 0,
    then: () => Yup.string().required(i18n.t('auth.min_interests')),
    otherwise: () => Yup.string() // unnecessary
  })
});

const distancesSchema = Yup.object().shape({
  distances: Yup.number(),
  location: Yup.string().required(i18n.t('mix.city_required'))
});

// Types
export type NpoLoginData = Yup.InferType<typeof npoLoginSchema>;
export type NpoForgotPasswordData = Yup.InferType<typeof npoForgotPasswordSchema>;
export type SignInData = Yup.InferType<typeof signInSchema>;
export type InterestsData = Yup.InferType<typeof interestsSchema>;
export type DistancesData = Yup.InferType<typeof distancesSchema>;

// Resolvers
export const npoLoginResolver = yupResolver(npoLoginSchema);
export const npoForgotPasswordResolver = yupResolver(npoForgotPasswordSchema);
export const signInResolver = yupResolver(signInSchema);
export const interestsResolver = yupResolver(interestsSchema);
export const distancesResolver = yupResolver(distancesSchema);
